import { useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import SearchBox from "../../../../SearchBox/SearchBox";

function TitleList({ chooseSearchVal }) {

    const [showSearch, setShowSearch] = useState(false)


    return (
        <>
            {showSearch ?
                <div className="flex flex-row-reverse items-center py-1 border-b border-slate-200">
                    <SearchBox chooseSearchVal={chooseSearchVal} />
                    <BiArrowBack
                        onClick={() => setShowSearch(false)}
                        className="text-slate-400 ml-1"
                        size={20}
                    />
                </div>
                :
                <div className="flex flex-row-reverse items-center justify-between bg-purpleMedium02 px-4 py-3 rounded-t border-b border-slate-200">
                    <p className="t-purpleDark font-bold">لیست کانال ها</p>
                    <img
                        onClick={() => setShowSearch(true)}
                        src="/image/icon/searchIcon.png"
                        className="w-6"
                    />
                </div>
            }
        </>
    )
}
export default TitleList;